<template lang="pug">
  div(:class="$style.loginPage")
    el-card(:class="$style.card")
      el-row
        el-col(align="middle")
          img(:class="$style.logo" src="~@/assets/HVU_Logo.svg")
          p(:class="$style.title") Master Admin Login
      el-form(
        class="padding-top-15"
        :model="user"
        :rules="userRules"
      )
        el-form-item(prop="email")
          el-input(
            v-model="user.email"
            placeholder="Email"
            prefix-icon="el-icon-message"
          )

        el-form-item(prop="password")
          el-input(
            v-model="user.password"
            type="password"
            placeholder="Password"
            prefix-icon="el-icon-lock"
          )

        el-row
          el-col(:span="12" align="left")
            el-checkbox(v-model="isRemember") Remember Me
          el-col(:span="12" align="right")
            a(:class="$style.link") Forgot your password

      el-row.padding-top-15.padding-bottom-15
        el-col(align="middle")
          el-button(
            type="primary"
            :class="$style.button"
            @click="login"
            :loading="loading"
          ) Login
</template>

<script>
  import masterApiCall from '@/masteradmin/utils/api'
  import { ACTION_LOGIN } from '@/store/actions'
  import { PAGE_MASTER } from '@/masteradmin/router/routeNames'

  export default {
    data() {
      return {
        user: {
          email: '',
          password: '',
        },

        userRules: {
          email: [{
            required: true,
            message: 'Please input email address',
            trigger: 'blur,change',
          }, {
            type: 'email',
            message: 'Please input correct email address',
            trigger: 'blur,change',
          }],
          password: [{
            required: true,
            message: 'Please input password',
            trigger: 'blur,change',
          }, {
            min: 8,
            message: 'Length should be 8 or more',
            trigger: 'blur,change',
          }],
        },

        isRemember: true,
        loading: false,
      }
    },

    methods: {
      login() {
        this.loading = true
        masterApiCall('post', '/admins/login', this.user)
          .then(({ data }) => {
            this.$store.dispatch(ACTION_LOGIN, {
              user: data.user,
              token: data.token,
              isRemember: this.isRemember,
            })
              .then(() => {
                this.loading = false
                this.$router.push({ name: PAGE_MASTER })
              })
          }, (err) => {
            this.loading = false

            if (err.response.status === 401) {
              this.$notify.error({
                title: 'Login error',
                message: 'Wrong email or password',
                position: 'bottom-right',
              })
            } else {
              this.$notify.error({
                title: 'Server Error!',
                message: 'We are sorry! Please try again',
                position: 'bottom-right',
              })
            }
          })
      },
    },
  }
</script>

<style module>
  .logo {
    width: 75%;
  }

  .loginPage {
    margin: 100px auto;
  }

  .title {
    font-size: 1.5em;
    line-height: 1.75em;
    margin: 10px;
    color: var(--hvu-blue);
  }

  .card {
    border-radius: 16px;
    padding-left: 50px;
    padding-right: 50px;
    width: 400px;
  }

  .logo {
    margin-top: 30px;
  }

  .inputIcon {
    width: 17px;
  }


</style>



// WEBPACK FOOTER //
// client/masteradmin/pages/Login/Login.vue